const mainElementAi = document.createElement('div');

const backgroundImageDesktopAi = "//thesleepcompany.in/cdn/shop/files/Arrange-a-call-back_Website-Popup_630X490-Dec_867409d3-becf-4d88-94b1-243b1a1ac99d.jpg?v=1787194911";
const backgroundImageMobileAi = "//thesleepcompany.in/cdn/shop/files/Arrange-a-call-back_Website-Popup_630X490-Dec_867409d3-becf-4d88-94b1-243b1a1ac99d.jpg?v=1787194911";
const successImageAi = "//thesleepcompany.in/cdn/shop/files/Frame_10000064555_8ce9e307-76d2-434d-8e3f-742b2ec28bd9.png?v=1787175366";


mainElementAi.innerHTML = `<div id="myacbcusmodal-ai-mattress" class="acbcusmodal" style="display: none;">
      <!--div class="add_acb-confetti" id="dev_add_acb-confetti"></div-->
      <div class="acbcusmodal-content">
        
        <!-- <h4 id="header-text" class="acbftsy">Still Confused ?</h4> -->
            <img class="ABimage"id="ABimage"src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Ai-Mattress-Popup-750x750.jpg?v=1750054242"alt="ABtest">
            <img class="ABimage-123"id="ABimage-123"src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Ai-Mattress-Popup-750x750.jpg?v=1750054242"alt="ABtest">
            <img id="success-img" class="success-img-ai-mattress-popup" src="${successImageAi}"alt="ABtest">
            <div class="acbcusmodal-content-abTest">
              <span class="acbcusclose-ai-mattress ai-mattress-popup-close-btn">&times;</span>
              <!-- <span class="acbcusclose"id="arrangecallbackclosebutton">&times;</span> -->
        <!-- <p id="header-subtext" class="acbftsy">Talk to our sleep experts for exclusive offers, product guidance.</p> -->
        <!--
          p id="header-subtext" class="acbftsy">Talk to our comfort experts <br>Enjoy an exclusive offer on chairs, only for today<br>Use Coupon: COMFORT1000.</p
        -->
        <form
          id="contact-form-ai-mattress-popup"

          method="POST"
          action="https://script.google.com/macros/s/AKfycbxuV23O7syDHCKsXc2A9VhR7v29XlGr6kglZfjv1ovklvtXeYYiG4uiSewKj4pvx6JoAA/exec"
        >
          <input
            type="tel"
            id="phone_no"
            name="phone_no"
            class="acbcusmodal-input uid-phone-no ai-mattress-popup-phone ai-mattress-popup-input"
            placeholder="Phone"
            pattern="[0-9]{10}"
            required
            maxlength="10"
            onkeyup="validatePhoneNumberAi()"
            onBlur="validatePhoneNumberAi()"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          >
          <p id="phone-alert" class="ai-mattress-popup-phone-alert" style="display: none;">&nbsp;</p>
          <input
            type="text"
            id="pincode_no"
            name="zip"
            class="acbcusmodal-input pincode-input somnathmaurya ai-mattress-popup-pincode ai-mattress-popup-input"
            placeholder="Pincode"
            pattern="[0-9]{6}"
            maxlength="6"
            oninput="myZipcodeAi();"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          >
          <p id="zipcode-alert" class="ai-mattress-popup-zipcode-alert" style="display: none;">&nbsp;</p>
          <input type="hidden" id="email" name="email" value="">
          <input type="hidden" id="current-url" name="current_url" value="">
          <input type="hidden" id="PMOO" name="PMOO" value="">
          <input type="hidden" id="UTMCAMPS" name="UTMCAMPS" value="">
          <input type="hidden" id="UTMSOURCE" name="UTMSOURCE" value="">
          <div id="btn-container">
            <button type="submit" onclick="uidForm(this)" id="arrangecallback_submitmain" class="acbcusmodal-submit arrange_callback_submit ai-mattress-popup-submit">
              SUBMIT
              <div class="loader-acb" id="loader_acb"></div>
            </button>
          </div>
          
        </form>
        <!-- <div id="sale-arrange-success-message ai-mattress-popup-success-message" class="acbftsy arrange_callback_submit_msg" style="display:none;">
          Thank You! We will contact you shortly...
        </div> -->
        <div id="sale-arrange-success-message" class="acbftsy arrange_callback_submit_msg ai-mattress-popup-success-message"style="display:none;"> <span class="ABtxt1">Thank You!</span><br>
              <span class="ABtxt2">We have received your enquiry. Our team will get back to you shortly.</span></div>
        </div>      
      </div>
    </div>`

document.body.appendChild(mainElementAi);



function validatePhoneNumberAi() {
  var phoneInput = document.querySelector('.ai-mattress-popup-phone');
  var phoneAlert = document.querySelector('.ai-mattress-popup-phone-alert');
  var submitButton = document.querySelector('.ai-mattress-popup-submit')
  var zipcodeAlert = document.querySelector('.ai-mattress-popup-zipcode-alert');
  var phoneNumber = phoneInput.value.trim();

  // Check if the phone number is not empty and starts with 6, 7, 8, or 9
  if (phoneNumber !== "" && /^\d+$/.test(phoneNumber) && /^[6-9]/.test(phoneNumber)) {
      phoneAlert.style.display = "none";

  } else {
      phoneAlert.style.display = "block";
      phoneAlert.innerHTML = "Invalid phone number";

      submitButton.disabled = true;
      return; // Exit the function if the phone number is invalid
  }

  // Check if both phone number and pin code are valid to enable the submit button
  if (phoneAlert.style.display === "none" && zipcodeAlert.style.display === "none") {
      submitButton.disabled = false;
  }
}

function myZipcodeAi() {
  var pincodeInput = document.querySelector('.ai-mattress-popup-pincode');
  var zipcodeAlert = document.querySelector('.ai-mattress-popup-zipcode-alert')
  var submitButton = document.querySelector('.ai-mattress-popup-submit')
  var pincodeValue = pincodeInput.value.trim();

  // Check if pin code is empty or invalid
  if (pincodeValue !== "" && /^\d{6}$/.test(pincodeValue) && pincodeValue !== "123456") {
      zipcodeAlert.style.display = "none";
      submitButton.disabled = false; // Enable the button if pin code is valid

  } else {
      zipcodeAlert.style.display = "block";
      zipcodeAlert.innerHTML = "Invalid pin code";
      submitButton.disabled = true;
      return; // Exit the function if the pin code is invalid
  }
} 

document.querySelector('.ai-mattress-popup-close-btn').addEventListener('click', function () {
  document.getElementById('myacbcusmodal-ai-mattress').style.display = 'none';
  localStorage.setItem('aiMattressPopupUserClosed', 'true'); // Set flag to not show again
})

const acbcusmodalAi = document.getElementById("myacbcusmodal-ai-mattress");

  setTimeout(function () {
    const shouldShowPopup = sessionStorage.getItem('shouldShowAiMattressPopup');
    const acbpopupVisible = document.getElementById('myacbcusmodal')?.style.display === 'block';
    if ((shouldShowPopup == null || shouldShowPopup === 'true' ) && localStorage.getItem('aiMattressPopupUserClosed') !== 'true' && !acbpopupVisible) {
      acbcusmodalAi.style.display = 'block';
      sessionStorage.setItem('shouldShowAiMattressPopup', 'false');
    }

  }, 30000);

//Reset pincode and phone alert when user is typing



document.addEventListener('DOMContentLoaded', function () {

  document.getElementById('contact-form-ai-mattress-popup').addEventListener('submit', function (event) {
    event.preventDefault(); // Prevent the default form submission

    var aiPhoneInput = document.querySelector('.ai-mattress-popup-phone');
    var aiPincodeInput = document.querySelector('.ai-mattress-popup-pincode');
    var aiZipcodeAlert = document.querySelector('.ai-mattress-popup-zipcode-alert')
    var aiPhoneAlert = document.querySelector('.ai-mattress-popup-phone-alert');
    var aiSubmitButton = document.querySelector('.ai-mattress-popup-submit')
    var aiPincodeValue = pincodeInput.value.trim();
    const aiPageUrl = window.location.href;

    if (aiPhoneInput.value.trim() === "" || !/^[6-9]\d{9}$/.test(aiPhoneInput.value.trim())) {
      aiPhoneAlert.style.display = "block";
      aiPhoneAlert.innerHTML = "Invalid phone number";
      aiSubmitButton.disabled = true;
      return; // Exit if phone number is invalid
    } else {
      aiPhoneAlert.style.display = "none";
    }

    if (aiPincodeInput.value.trim() === "" || !/^\d{6}$/.test(aiPincodeInput.value.trim())) {
      aiZipcodeAlert.style.display = "block";
      aiZipcodeAlert.innerHTML = "Invalid pin code";
      aiSubmitButton.disabled = true;
      return; // Exit if pin code is invalid
    }
    else {
      aiZipcodeAlert.style.display = "none";
    }

    const aiFormData = {
            "phone": aiPhoneInput.value.trim(),
            "source": "Arrange A Callback - AI",
            "page_url": aiPageUrl,
            "pincode": aiPincodeValue,
            "activity_note": aiPincodeValue,
            "activity_source": "Arrange A Callback - AI",
            "lead_status": "Store",
            "mx_custom_4": window.productDetails.type,
            "mx_custom_7":  "",
            "mx_custom_8": "",
            "source_page": aiPageUrl,
            "product_type":  window.productDetails.type,
            "lead_status": "Tier 2",
            "is_web_engage_event": true,
            "mx_mobile_device": getDeviceModel(),
            "mx_mobile_os": getOSWithVersion(),
            "web_engage_data": {
                "product_category": window.productDetails.type,
                "product_subcategory": window.productDetails.titleJson,
                "product_page": aiPageUrl,
                "pincode": aiPincodeValue
            },
          "web_engage_user_data": {
                "category": window.productDetails.type,
                "subcategory": window.productDetails.titleJson
            }        
        };

    fetch('https://apis.thesleepcompany.in/lead/datafeed', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(aiFormData)
      })
          .then(response => {
              if (!response.ok) {
                  throw new Error('Failed to submit data');
              }
              return response.json();
          })
      
    //submit
    document.getElementById('contact-form-ai-mattress-popup').style.display = 'none';
    document.querySelector('.success-img-ai-mattress-popup').style.display = 'block';
    document.querySelector('.ai-mattress-popup-success-message').style.display = 'block';
  })
})
